import * as z from 'zod/mini'
import { Notification } from '../../business/notifications/notification'

/** Rows a page of the desktop table shows, and a phone's "Načítať ďalšie" adds. Paging is the browser's. */
export const NOTIFICATIONS_PAGE_SIZE = 25

/**
 * The most notifications `GET notifications` returns, newest first. The list loads once and is filtered, searched,
 * counted and paged in the browser (docs/notifications.md, _The list_).
 */
export const NOTIFICATIONS_LIST_MAX = 2000

/** A bulk request's ids: a page of the table, or what a phone has loaded. "Označiť všetky" is its own request. */
export const NOTIFICATIONS_BULK_MAX = 100

export interface GetNotificationsResponse {
  /** The caller's notifications, newest first, at most `NOTIFICATIONS_LIST_MAX`. */
  results: Notification[]
  /** Every unread notification of the caller, beyond the cap too: the badge. */
  unread: number
  /** More notifications exist than `results` holds. */
  capped: boolean
}

export interface GetUnreadNotificationsResponse {
  unread: number
}

export const notificationBulkActions = ['read', 'unread', 'delete', 'restore'] as const
export type NotificationBulkAction = (typeof notificationBulkActions)[number]

/** Every id must be the caller's, or nothing is changed. */
export const notificationsBulkBody = z.object({
  ids: z.array(z.uuid()).check(z.minLength(1), z.maxLength(NOTIFICATIONS_BULK_MAX)),
  action: z.enum(notificationBulkActions),
})
export type NotificationsBulkBody = z.infer<typeof notificationsBulkBody>

export interface NotificationsBulkResponse {
  /** Rows the action changed. */
  affected: number
  /** The caller's unread count after it: the badge. */
  unread: number
}
